import React, { useState } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import underline from "../assets/underline.png";

const MainPageCard = ({ title, image, link }) => {
    const [hovered, setHovered] = useState(false);

    return (
        <Link
            to={link}
            style={{
                textDecoration: "none",
                flex: "0 0 auto",       // Keeps card width fixed in flex container
                width: "270px",         // Set card width
                margin: "0",            // Remove extra margin
            }}
        >
            <Card
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                sx={{
                    width: "100%",
                    height: "360px",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    borderBottomLeftRadius: "0px",
                    borderBottomRightRadius: "0px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    boxShadow: 4,
                    transition: "transform 0.3s ease-in-out",
                    position: "relative",
                    "&:hover": {
                        transform: "scale(1.02)",
                    },
                }}
            >
                <CardContent
                    sx={{
                        flexGrow: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        padding: "16px 16px 0px 16px",
                        minHeight: "24px",
                        position: "relative",
                        backgroundColor: "rgba(208, 190, 163, 0.33)",

                        "&:last-child": {
                            paddingBottom: 0,
                        },
                    }}
                >

                    <Typography
                        variant="h6"
                        sx={{
                            fontFamily: "'Poppins', sans-serif",
                            color: "#000",
                            marginBottom: "6px",
                            fontSize: "1.1rem",
                            textTransform: "none", // Allow lowercase
                        }}
                    >
                        {title}
                    </Typography>
                    <div
                        style={{
                            width: "200px",
                            height: "40px",
                            marginTop: "-30px",
                            marginRight: "-120px",
                            backgroundImage: `url(${underline})`,
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            opacity: hovered ? 1 : 0,
                            transition: "opacity 0.3s ease-in-out",
                        }}
                    />

                </CardContent>

                <div
                    style={{
                        width: "100%",
                        flexGrow: 1,
                        position: "relative",
                        zIndex: 3,
                        overflow: "hidden",
                    }}
                >
                    <img
                        src={image}
                        alt={title}
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "45% center",
                        }}
                    />
                </div>
            </Card>
        </Link>
    );
};

export default MainPageCard;
